// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1qW1F","left":"StickyBox_left__Kv5nB","right":"StickyBox_right__3XV31"};